var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ug-table"},[_c('div',{ref:"ugTableHead",staticClass:"ug-table__head",style:({ top: _vm.stickyTop })},[_vm._t("header")],2),_c('div',{staticClass:"ug-table__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }